var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 38,
    viewBox: "0 0 180 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3676 0.526855C12.2537 0.526855 11.2994 1.1623 10.9811 2.27631L0 37.1283H6.78975L16.7092 6.06977L26.4168 37.1283H33.2066L22.2267 2.27631C21.9085 1.1623 20.9529 0.526855 19.8389 0.526855H13.3676Z",
    fill: "#5FAA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1314 0.526611H54.5006V29.6489C54.5006 34.0518 56.6225 37.2346 62.7227 37.2346C67.6561 37.2346 72.6424 37.1816 77.2574 36.7571L76.9922 31.6116H64.2611C61.9271 31.6116 61.1314 30.816 61.1314 28.588V0.526611Z",
    fill: "#5FAA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.239 0C106.404 0 103.22 0.155714 99.2944 0.526962V37.1285C103.697 37.4999 107.198 37.5524 113.882 37.5524C122.423 37.5524 125.832 35.5492 125.871 27.903C125.916 19.0197 121.014 18.5029 117.877 18.1469C122.637 17.7247 124.796 15.4255 124.757 9.54897C124.708 2.01648 121.469 0 112.239 0ZM105.82 5.4594L111.92 5.4598C116.8 5.46013 118.391 6.41563 118.391 10.5002C118.391 13.3155 118.018 13.4385 117.195 14.6001C116.022 16.2566 114.49 16.789 112.246 18.1481C114.342 19.3985 116.377 20.1265 117.79 21.8382C118.859 23.1317 119.24 23.9523 119.24 26.7862C119.24 31.2225 117.702 32.196 112.769 32.196C110.17 32.196 107.836 32.1963 105.82 32.1434V20.5791V15.7521L105.82 5.4594Z",
    fill: "#5FAA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.206 0.526855C158.092 0.526855 157.138 1.1623 156.819 2.27631L145.838 37.1283H152.628L162.547 6.06977L172.255 37.1283H179.045L168.065 2.27631C167.747 1.1623 166.791 0.526855 165.677 0.526855H159.206Z",
    fill: "#5FAA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerde);
export default __webpack_public_path__ + "static/media/logo-verde.995aed097cd6b7f8cbacabdebedb51b8.svg";
export { ForwardRef as ReactComponent };